import { render, staticRenderFns } from "./DiseaseAreaGalleryComponent.vue?vue&type=template&id=6a0e6ab8&"
import script from "./DiseaseAreaGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./DiseaseAreaGalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseAreaGalleryComponent.vue?vue&type=style&index=0&id=6a0e6ab8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports